import * as angular from "angular";
import {IController, IIntervalService} from "angular";

export class AgentAssignSwapTableCtrl implements IController {

  agentList: any;
  selectedIds: any;
  searchQuery: any;
  isIgnoreScore: boolean;

  onAssign: Function;
  onGetDrivers: Function;

  private intervalRef: any;
  private defaultCountValue: any;
  private counter: any;

  /* @ngInject */
  constructor(private $interval: IIntervalService) {
  }

  $onInit() {
    this.defaultCountValue = 3;
    this.counter = undefined;
  }

  $onChanges(changes) {
    if (changes.selectedIds && !changes.selectedIds.isFirstChange()) {
      if (this.selectedIds.length) {
        this.counter = this.defaultCountValue;
        this._resetInterval();
        this.intervalRef = this.$interval(() => {
          if (this.counter >= 0) {
            this.counter = this.counter - 1/10;
          }
          if (this.counter < 0) {
            this.$interval.cancel(this.intervalRef);
            this.intervalRef = undefined;
            this.counter = undefined;
            this.onGetDrivers();
          }
        }, 100);

        this.intervalRef
          .then(() =>{})
          .catch(() =>{})

      } else {
        this.counter = undefined;
        this._resetInterval();
      }
    }
  };

  private _resetInterval() {
    if (this.intervalRef) {
      this.$interval.cancel(this.intervalRef);
      this.intervalRef = undefined;
    }
  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentAssignSwapTable', {
    bindings: {
      agentList: '<',
      selectedIds: '<',
      searchQuery: '<',
      isIgnoreScore: '<?',
      onAssign: '&',
      onGetDrivers: '&'
    },
    template: require('./agent-assign-swap-table.html').default,
    controller: AgentAssignSwapTableCtrl
  });

